import { render, staticRenderFns } from "./AdminContentCampaignTabularActions.vue?vue&type=template&id=2fc791e0&"
import script from "./AdminContentCampaignTabularActions.vue?vue&type=script&lang=ts&"
export * from "./AdminContentCampaignTabularActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports